function deleteCartProduct(product_key){
  if(confirm('削除しますか？')){
    var data =  {
          "id": product_key,
          "quantity": 0,
    }
    // console.log(data);
    var url = "/cart/change.js";
    var request = new XMLHttpRequest();
    var result = "";
    request.onreadystatechange = function() {
      if (request.readyState != 4) {
        // リクエスト中
      } else if (request.status != 200) {
        // 失敗
      } else {
        // 取得成功
        result = request.responseText;
      }
    }
    request.open('POST', url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
    var cart = new theme.CartDrawer;
    cart.init();
    cart.open();
  }
  return false;
}
